import { logger } from './logger';

/**
 * Browser translation swaps React's text nodes for `<font>` wrappers, so React's next
 * insertBefore/removeChild hits a node that is no longer a child and crashes the page.
 * Degrades those calls instead of throwing — see https://github.com/facebook/react/issues/11538.
 */
export function installTranslationDomGuard() {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    const wasMovedAway = child.parentNode !== this;
    if (wasMovedAway) {
      logger.warn('removeChild skipped: node was moved by an outside script (likely page translation)');
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, child: Node | null): T {
    const referenceWasMovedAway = child !== null && child.parentNode !== this;
    // Append instead of dropping the node, so new content still appears
    if (referenceWasMovedAway) {
      logger.warn('insertBefore appended instead: reference node was moved by an outside script (likely page translation)');
      return originalInsertBefore.call(this, node, null) as T;
    }
    return originalInsertBefore.call(this, node, child) as T;
  };
}
